module.exports = __webpack_public_path__ + "static/media/ProjectSteps_001.9f256671.png";